const o=(o,t)=>o<=t,t=(o,t)=>o-1>=t,c=(o,t)=>o>t&&o-1<t;export{t as isIconEmpty,o as isIconFilled,c as isIconMixed};
